import { useAuth } from "@/context/AuthContext";
import { useCart } from "@/context/CartContext";
import { useSite } from "@/context/SiteContext";
import { minimumOrderAmount } from "@/lib/product";

/**
 * Minimum bestelbedrag (excl. BTW) voor het land van de klant.
 * CRM is leidend; anders de tijdelijke instelling uit het beheer.
 */
export function useMinimumOrder() {
  const { totalExcl } = useCart();
  const { account, verzendregels } = useAuth();
  const { instellingen } = useSite();
  const regel = minimumOrderAmount({ account, verzendregels, instellingen });
  if (!regel) return { minimum: null, bron: null, gehaald: true, ontbreekt: 0 };
  const ontbreekt = Math.max(0, regel.bedrag - totalExcl);
  return { minimum: regel.bedrag, bron: regel.bron, gehaald: ontbreekt <= 0.005, ontbreekt };
}
